import { useEffect, useRef, useState } from 'react';

/**
 * Triggers the hero's CSS animations once, the first time it scrolls
 * into view (rather than immediately on mount, which is what plain
 * CSS keyframes do). Add the returned `playing` boolean as a class
 * on the wrapper (see hero.module.css: ".heroRoot.playing .draw" etc).
 */
export function useHeroInView(threshold = 0.3) {
  const ref = useRef(null);
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setPlaying(true);
          observer.disconnect(); // only ever play once
        }
      },
      { threshold }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [threshold]);

  return { ref, playing };
}
